/**
 * Fun "Coming Soon" placeholder for portcos that don't have Amazon data yet.
 */

import { Link, useSearchParams } from "react-router-dom";
import { PortcoSubNav } from "../ui-components/PortcoSubNav";

export function AmazonComingSoon() {
  const [params] = useSearchParams();
  const portcoId = params.get("from") || "";
  const portcoName = params.get("name") || "This brand";

  return (
    <div className="w-full max-w-6xl">
      {portcoId && (
        <>
          <div className="mb-4">
            <Link
              to={`/portco/${portcoId}`}
              className="text-sm text-gray-400 hover:text-wmp-500 no-underline"
            >
              &larr; Back to {portcoName}
            </Link>
          </div>
          <div className="mb-6">
            <PortcoSubNav portcoId={portcoId} />
          </div>
        </>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="py-20 px-8 text-center">
          {/* Package / box icon */}
          <div className="relative inline-block mb-6">
            <svg
              className="w-24 h-24 text-gray-200 animate-bounce"
              style={{ animationDuration: "3s" }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
              />
            </svg>
            <span
              className="absolute -top-1 -right-1 text-2xl animate-ping"
              style={{ animationDuration: "2s" }}
            >
              *
            </span>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Amazon Dashboard Coming Soon!
          </h2>
          <p className="text-gray-500 text-lg max-w-md mx-auto mb-2">
            {portcoName}'s Amazon analytics are on the way.
          </p>
          <p className="text-gray-400 text-sm max-w-sm mx-auto">
            We're connecting the Amazon data pipeline. Check back soon for sales
            trends, profitability, inventory health, and returns analysis.
          </p>

          <div className="mt-8 max-w-xs mx-auto">
            <div className="flex justify-between text-xs text-gray-400 mb-1">
              <span>Progress</span>
              <span>Setting up FBA...</span>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-amber-400 to-orange-500 rounded-full animate-pulse"
                style={{ width: "35%" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
